import { render, staticRenderFns } from "./PhoneSelected.vue?vue&type=template&id=5d50ba76"
import script from "./PhoneSelected.vue?vue&type=script&lang=ts"
export * from "./PhoneSelected.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports